import getModels from '../api/getModels';
import LastEvent from "../components/LastEvent.jsx"

export default function getAllModels() {
    return (dispatch, state) => {
        dispatch({type: "MODEL_GET_STARTING"});
        getModels().then(models => {
            LastEvent().then(historyModels => {
                dispatch({type: "MODEL_GET_ALL", models, historyModels: historyModels});
            }).catch( error => {
                dispatch({type: "MODEL_GET_ALL_ERROR", error:error});
            })
        }).catch( error =>{
            console.error(error)
            dispatch({type: "MODEL_GET_ALL_ERROR", error:error});
        })
    }
}